import { render, staticRenderFns } from "./DataLog.vue?vue&type=template&id=5a96ecc8&scoped=true&"
import script from "./DataLog.vue?vue&type=script&lang=js&"
export * from "./DataLog.vue?vue&type=script&lang=js&"
import style0 from "./DataLog.vue?vue&type=style&index=0&id=5a96ecc8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a96ecc8",
  null
  
)

export default component.exports